import { projectRequest } from 'store/utils/request';

export const checkIntentNameRequest = (name, exception) =>
  projectRequest.get(`/intents/`, {
    params: Object.assign(
      {
        name__iexact: name,
      },
      exception
        ? {
            id__not__in: exception,
          }
        : null,
    ),
  });

export const partialExport = path => async ids => {
  try {
    return await projectRequest.post(`/${path}/export/`, {
      params: ids ? { id__in: ids.join() } : null,
    });
  } catch (error) {
    throw error;
  }
};

export const getIntentsRequest = async params => {
  try {
    return await projectRequest.get(`/intents/`, {
      params,
    });
  } catch (error) {
    throw error;
  }
};

export const addIntentRequest = async data => {
  try {
    return await projectRequest.post(`/intents/`, data);
  } catch (error) {
    throw error;
  }
};

export const getIntentRequest = async intentId => {
  try {
    return await projectRequest.get(`/intents/${intentId}/`);
  } catch (error) {
    throw error;
  }
};

export const updateIntentRequest = async (intentId, data) => {
  try {
    return await projectRequest.put(`/intents/${intentId}/`, data);
  } catch (error) {
    throw error;
  }
};

export const partialUpdateIntentRequest = async (intentId, data) => {
  try {
    return await projectRequest.patch(`/intents/${intentId}/`, data);
  } catch (error) {
    throw error;
  }
};

export const deleteIntentRequest = async intentId => {
  try {
    return await projectRequest.delete(`/intents/${intentId}/`);
  } catch (error) {
    throw error;
  }
};

export const trainRequest = async () =>
  projectRequest.post(
    `/train/`,
    {},
    {
      timeout: 5 * 60 * 1000,
    },
  );
